module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("Uploader")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("Please log in")]), _vm._v(" "), _c('div', {
    staticClass: "form__input-group form__input-group--full form__input-group--wrap"
  }, [_c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.username),
      expression: "auth.username"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.auth.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form__label--hidden",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.auth.password),
      expression: "auth.password"
    }],
    staticClass: "form__input",
    class: {
      'form__input--error': _vm.authError
    },
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.auth.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.auth.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button form__submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Log in\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'password-reset'
    }
  }, [_vm._v("Forgotten password?")])], 1), _vm._v(" "), (_vm.authMessage) ? _c('p', {
    staticClass: "form__help--error mr-2"
  }, [_vm._v(_vm._s(_vm.authMessage))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "form__link",
    attrs: {
      "to": 'register'
    }
  }, [_vm._v("Register")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d61f24","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 226
// module chunks = 1